
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MixingItemsDialog extends Common.GridEditorDialog<MixingItemsRow> {
        protected getFormKey() { return MixingItemsForm.formKey; }
        //protected getIdProperty() { return MixingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MixingItemsRow.localTextPrefix; }
        //protected getNameProperty() { return MixingItemsRow.nameProperty; }
        //protected getService() { return MixingItemsService.baseUrl; }
        protected getDeletePermission() { return MixingItemsRow.deletePermission; }
        protected getInsertPermission() { return MixingItemsRow.insertPermission; }
        protected getUpdatePermission() { return MixingItemsRow.updatePermission; }

        protected form = new MixingItemsForm(this.idPrefix);
        constructor() {
            super();
            //Make grid full width
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.ImageName);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.GrossAmount);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            //Cascade Code
            let prior = $(".ui-dialog").eq(-2);
            if (prior.length > 0) {
                $(document).one("dialogopen", (e) => {
                    this.element.dialog().dialog('option', 'position', { my: 'left top', at: 'left+24 top+24', of: prior[0] });
                })
            }

            if (this.entity.HasBom == false) {
                q.hideEditorTab(this.form.ImageName);
                
            }
        }
    }
}